import transformCategoryString from './transformCategoryString';
import { reviewSchema } from '../schemas';

const constructObjectProduct = (product, productRating) => {
  var _productRating$userRe, _productRating$userRe2, _product$attributes, _product$category, _product$subcategory;

  const reviewContent = productRating == null ? void 0 : (_productRating$userRe = productRating.userReviews) == null ? void 0 : (_productRating$userRe2 = _productRating$userRe.items) == null ? void 0 : _productRating$userRe2.map(el => reviewSchema(el)).filter(el => el);
  const reviewObject = !reviewContent ? {} : {
    review: reviewContent
  };
  const color = product == null ? void 0 : (_product$attributes = product.attributes) == null ? void 0 : _product$attributes.find(el => el.type === 'color');
  return Object.assign({
    description: product.description || product.title,
    category: transformCategoryString(product == null ? void 0 : (_product$category = product.category) == null ? void 0 : _product$category.name, product == null ? void 0 : (_product$subcategory = product.subcategory) == null ? void 0 : _product$subcategory.name),
    color: color == null ? void 0 : color.current,
    itemCondition: 'https://schema.org/NewCondition',
    sku: product == null ? void 0 : product.id
  }, reviewObject);
};

export default constructObjectProduct;